"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InventorySystem = void 0;
const gotti_1 = require("gotti");
const Constants_1 = require("../../../Shared/Constants");
const types_1 = require("../../../Shared/types");
const GameData_1 = require("../../../Shared/GameData");
const assert = require("assert");
class InventorySlot extends PIXI.Container {
    constructor() {
        super();
        this.bg = new PIXI.Sprite(PIXI.Texture.EMPTY);
        this.itemSprite = new PIXI.Sprite(PIXI.Texture.EMPTY);
        this.quantityText = new PIXI.extras.BitmapText('', { font: 'gold' });
        this.itemName = null;
        this._quantity = 0;
        this.addChild(this.bg);
        this.addChild(this.itemSprite);
        this.addChild(this.quantityText);
    }
    set texture(t) {
        this.itemSprite.texture = t;
        if (t) {
            if (t.width < this.bg.width) {
                this.itemSprite.x = (this.bg.width / 2) - (t.width / 2);
            }
            else {
                const diff = t.width - this.bg.width;
                this.itemSprite.x = diff / 2;
            }
            if (t.height < this.bg.height) {
                this.itemSprite.y = (this.bg.height / 2) - (t.height / 2);
            }
            else {
                const diff = t.height - this.bg.height;
                this.itemSprite.y = diff / 2;
            }
        }
    }
    get quantity() { return this._quantity; }
    set quantity(v) {
        this._quantity = v || 0;
        if (v && v > 1) {
            this.quantityText.text = `${v}`;
        }
        else {
            this.quantityText.text = '';
        }
    }
}
const INVENTORY_COLUMNS = 8;
const INVENTORY_ROWS = 2;
class ContextMenuOption extends PIXI.Container {
    constructor(option, callback) {
        super();
        this.bg = new PIXI.Sprite();
        this.callback = callback;
        this.addChild(this.bg);
        this.bg.y -= 3;
        this.bg.x -= 2;
        this.bitmapText = new PIXI.extras.BitmapText(option, { font: 'gold' });
        this.addChild(this.bitmapText);
    }
}
class ContextMenu extends PIXI.Container {
    constructor(bgTexture, selectedOptionTexture, checkMarkTexture) {
        super();
        this.bg = new PIXI.Sprite();
        this.options = [];
        this.selectedOptionTexture = selectedOptionTexture;
        this.bg.texture = bgTexture;
        this.addChild(this.bg);
        this.checkMarkSprite = new PIXI.Sprite(checkMarkTexture);
        this.addChild(this.checkMarkSprite);
    }
    refreshCheckMark(netIsSelected, netIsEquipped, shovelIsSelected, shovelIsEquipped) {
        let found;
        if ((netIsEquipped && netIsSelected) || (shovelIsSelected && shovelIsEquipped)) {
            found = this.options.find(o => { var _a; return ((_a = o.bitmapText.text) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === "equip"; });
        }
        if (found) {
            this.checkMarkSprite.visible = true;
            this.checkMarkSprite.x = found.width + 3;
            this.checkMarkSprite.y = found.y;
        }
        else {
            this.checkMarkSprite.visible = false;
        }
    }
    clear() {
        this.visible = false;
        this.options.forEach(o => {
            o.destroy();
        });
        this.options.length = 0;
    }
    setSelectedOption(index) {
        this.options.forEach((o, i) => {
            if (i === index) {
                o.bg.texture = this.selectedOptionTexture;
            }
            else {
                o.bg.texture = PIXI.Texture.EMPTY;
            }
        });
    }
    setOptions(options) {
        this.clear();
        this.visible = true;
        const space = (this.bg.height - 30) / options.length;
        this.options = options.map((o, i) => {
            const opt = new ContextMenuOption(o.action, o.callback);
            opt.y = (space * i) + 15;
            opt.x = 5;
            this.addChild(opt);
            return opt;
        });
    }
}
class InventorySystem extends gotti_1.ClientSystem {
    constructor() {
        super(Constants_1.SYSTEMS.INVENTORY);
        this.pointerMoveDirection = -1;
        this.inventoryContainer = new PIXI.Container();
        this.inventorySlots = [];
        this.curSelectedIndex = 0;
        this.timeSinceInventoryToggled = 1;
        this.timeSinceInventoryAction = 1;
        this.inventoryPointer = new PIXI.Sprite();
        this.recenterInterface = this.recenterInterface.bind(this);
        this.inventoryContainer.visible = false;
    }
    updatePointer(delta) {
        if (!this.inventoryContainer.visible)
            return;
        if (this.isItemMenuOpen) {
            try {
                const maxX = this.itemContextMenu.x - (this.inventoryPointer.width / 2 + 7);
                const minX = maxX - 10;
                this.inventoryPointer.x += this.pointerMoveDirection * delta;
                if (this.inventoryPointer.x <= minX) {
                    this.inventoryPointer.x = minX;
                    this.pointerMoveDirection = 1;
                }
                else if (this.inventoryPointer.x > maxX) {
                    this.inventoryPointer.x = maxX;
                    this.pointerMoveDirection = -1;
                }
            }
            catch (err) {
                //console.error(err);
            }
        }
        else {
            try {
                const slotH = this.inventoryTextures.item.emptyBackground.height;
                const maxY = this.inventorySlots[this.curSelectedIndex].y + (slotH - 2);
                const minY = maxY - 4;
                this.inventoryPointer.y += this.pointerMoveDirection * delta;
                if (this.inventoryPointer.y <= minY) {
                    this.inventoryPointer.y = minY;
                    this.pointerMoveDirection = 1;
                }
                else if (this.inventoryPointer.y > maxY) {
                    this.inventoryPointer.y = maxY;
                    this.pointerMoveDirection = -1;
                }
            }
            catch (err) {
                //console.error(err);
            }
        }
    }
    get isOpen() {
        return this.inventoryContainer.visible;
    }
    isInventoryOpen() {
        return this.inventoryContainer.visible;
    }
    get isItemMenuOpen() {
        return this.itemContextMenu.visible;
    }
    onClear() {
    }
    addItem(itemName, quantity) {
        if (quantity < 0)
            throw new Error(`Use positive values for addItem api, if you want to remove items use removeItem, also with a positive value.`);
        if (!this.clientPlayer)
            throw new Error(`No player initialized.`);
        let firstOpen = -1;
        for (let i = 0; i < this.inventorySlots.length; i++) {
            if (!this.inventorySlots[i].itemName && firstOpen < 0) {
                firstOpen = i;
            }
            if (this.inventorySlots[i].itemName === itemName) {
                const nextquantity = this.inventorySlots[i].quantity + quantity;
                const e = { type: 'update', name: itemName, quantity };
                this.updateInventorySlot(i, itemName, nextquantity);
                this.globals.clientPlayer.emit(Constants_1.PLAYER_EVENTS.INVENTORY_CHANGE, e);
                this.assertInventoryStateSync();
                return { success: true };
            }
        }
        if (firstOpen > -1) {
            this.updateInventorySlot(firstOpen, itemName, quantity);
            const e = { type: 'add', name: itemName, quantity, index: firstOpen };
            this.globals.clientPlayer.emit(Constants_1.PLAYER_EVENTS.INVENTORY_CHANGE, e);
            this.assertInventoryStateSync();
            return { success: true };
        }
        return { success: false, error: 'No room in inventory.' };
    }
    assertInventoryStateSync(gameStateData) {
        gameStateData = gameStateData || this.globals.clientPlayer.gameState;
        let checked = [];
        for (let i = 0; i < gameStateData.inventory.length; i++) {
            const { index, name, quantity } = gameStateData.inventory[i];
            const { itemName: slotName, quantity: slotQuantity } = this.inventorySlots[index];
            if (slotName !== name) {
                //console.error('Expected the slot name at index', index, 'to be equal to game state:', name, 'but it was:', slotName)
                assert.strictEqual(slotName, name);
            }
            if (slotQuantity !== quantity) {
                //console.error('Expected the slot quantity at index', index, 'to be equal to game state:', quantity, 'but it was:', slotQuantity)
                assert.strictEqual(slotQuantity, quantity);
            }
            checked.push(parseInt(`${index}`));
        }
        for (let i = 0; i < this.inventorySlots.length; i++) {
            if (!checked.includes(i)) {
                const { itemName, quantity } = this.inventorySlots[i];
                if (itemName !== null) {
                    //console.error('Expected the slot name at index', i, 'to be equal to null because it was not in the game state but it was:', itemName)
                    assert.strictEqual(itemName, null);
                }
                if (itemName !== null) {
                    //console.error('Expected the slot quantity at index', i, 'to be equal to 0 because it was not in the game state but it was:', quantity)
                    assert.strictEqual(quantity, 0);
                }
            }
        }
    }
    removeItem(itemName, quantity) {
        if (quantity < 0)
            throw new Error(`Use positive values for removeItem api.`);
        if (!this.clientPlayer)
            throw new Error(`No player initialized.`);
        for (let i = 0; i < this.inventorySlots.length; i++) {
            if (this.inventorySlots[i].itemName === itemName) {
                const nextQuantity = this.inventorySlots[i].quantity - quantity;
                if (nextQuantity <= 0) {
                    this.removeInventorySlot(i);
                    const e = { type: 'remove', name: itemName, index: i, quantity };
                    this.globals.clientPlayer.emit(Constants_1.PLAYER_EVENTS.INVENTORY_CHANGE, e);
                    this.assertInventoryStateSync();
                    return { success: true };
                }
                else {
                    this.updateInventorySlot(i, itemName, nextQuantity);
                    const e = { type: 'update', name: itemName, index: i, quantity: -quantity };
                    this.globals.clientPlayer.emit(Constants_1.PLAYER_EVENTS.INVENTORY_CHANGE, e);
                    this.assertInventoryStateSync();
                    return { success: true };
                }
            }
        }
        return { success: false, error: `Did not find the item: ${itemName} in player's inventory` };
    }
    initInventoryFromGameState(gameState) {
        gameState.inventory.forEach(({ index, name, quantity }) => {
            this.updateInventorySlot(index, name, quantity);
        });
        this.assertInventoryStateSync(this.globals.gameStateData);
        if (this.honeyCount) {
            this.honeyCount.text = `${gameState.honey}`;
        }
    }
    handlePlayerHoneyUpdate(newHoneyAmount) {
    }
    onLocalMessage(message) {
        switch (message.type) {
            case Constants_1.MESSAGES.PLAYER_HONEY_UPDATE:
                this.honeyCount.text = `${message.data}`;
                break;
            case Constants_1.MESSAGES.EQUIPPED_SHOVEL:
            case Constants_1.MESSAGES.EQUIPPED_NET:
                this.isInventoryOpen() && this.refreshCheckMarks();
                break;
            case Constants_1.MESSAGES.PLAYER_HONEY_UPDATE:
                this.handlePlayerHoneyUpdate(message.data);
                break;
            case Constants_1.MESSAGES.CLIENT_PLAYER_ENTITY_INITIALIZED:
                this.clientPlayer = message.data;
                this.initInventoryFromGameState(this.clientPlayer.getComponent(Constants_1.SYSTEMS.GAME_STATE).data);
                break;
        }
    }
    onStart() {
        this.inventoryTextures = this.globals.gameTextures.inventory;
        this.itemIconTextures = this.globals.gameTextures.items.icons;
        this.inventoryPointer = new PIXI.Sprite();
        this.backgroundSprite = new PIXI.Sprite(this.inventoryTextures.background);
        this.inventoryContainer.addChild(this.backgroundSprite);
        const padX = 10;
        const slotW = (this.inventoryTextures.background.width - (padX * 2)) / INVENTORY_COLUMNS;
        const slotH = this.inventoryTextures.background.height / INVENTORY_ROWS;
        for (let row = 0; row < INVENTORY_ROWS; row++) {
            for (let col = 0; col < INVENTORY_COLUMNS; col++) {
                const slot = new InventorySlot();
                slot.x = (col * slotW) + padX + 2; // extra 2 padding since the left side of the interface texture is kind of wonky.
                slot.y = row * slotH + 5;
                if (col === 0 || col === 7) {
                    slot.y += 6;
                }
                if (col === 1 || col === 6) {
                    slot.y += 3;
                }
                if (row === 0) {
                    slot.y += 3;
                }
                else {
                    slot.y -= 3;
                }
                slot.bg.texture = this.inventoryTextures.item.emptyBackground;
                this.inventoryContainer.addChild(slot);
                this.inventorySlots.push(slot);
            }
        }
        const options = [];
        this.itemContextMenu = new ContextMenu(this.inventoryTextures.contextMenu.background, this.inventoryTextures.contextMenu.selectedBackground, this.inventoryTextures.contextMenu.checkMark);
        this.nameSprite = new PIXI.extras.BitmapText('', { font: 'gold2' });
        this.inventoryContainer.addChild(this.nameSprite);
        this.inventoryContainer.addChild(this.itemContextMenu);
        this.inventoryContainer.addChild(this.inventoryPointer);
        this.addApi(this.removeItem);
        this.addApi(this.addItem);
        this.addApi(this.isInventoryOpen);
        this.setSelectedItemSlot(0);
        this.globals.tileWorld.interfaceManager.addChild(this.inventoryContainer);
        this.honeycontainer = new PIXI.Container();
        this.honeySprite = new PIXI.Sprite(this.globals.gameTextures.honey);
        this.honeycontainer.addChild(this.honeySprite);
        this.honeyCount = new PIXI.extras.BitmapText('', { font: 'gold' });
        this.honeycontainer.addChild(this.honeyCount);
        this.honeySprite.x = 0;
        this.honeycontainer.y = this.globals.gameTextures.inventory.background.height - Math.round(this.honeySprite.texture.height * .8);
        this.honeyCount.y += this.honeySprite.texture.width / 2;
        this.inventoryContainer.addChild(this.honeycontainer);
        this.recenterInterface();
        if (typeof window !== 'undefined') {
            window.addEventListener('resize', this.recenterInterface);
        }
        else if (typeof document !== 'undefined') {
            document.addEventListener('resize', this.recenterInterface);
        }
    }
    removeInventorySlot(slotIndex) {
        if (this.inventorySlots[slotIndex].itemName) {
            this.inventorySlots[slotIndex].bg.texture = this.inventoryTextures.item.emptyBackground;
            this.inventorySlots[slotIndex].texture = PIXI.Texture.EMPTY;
            this.inventorySlots[slotIndex].quantity = 0;
            this.inventorySlots[slotIndex].itemName = null;
        }
    }
    updateInventorySlot(slotIndex, itemName, totalQuantity) {
        this.removeInventorySlot(slotIndex);
        const slot = this.inventorySlots[slotIndex];
        slot.itemName = itemName;
        const texture = this.itemIconTextures[itemName];
        slot.texture = texture;
        slot.quantity = totalQuantity;
    }
    setSelectedItemSlot(slotIndex) {
        var _a, _b, _c, _d;
        this.inventorySlots[this.curSelectedIndex].bg.texture = this.inventoryTextures.item.emptyBackground;
        if (this.isItemMenuOpen) {
            this.hideItemOptions();
        }
        this.curSelectedIndex = slotIndex;
        this.inventorySlots[slotIndex].bg.texture = this.inventoryTextures.item.selectedBackground;
        this.inventoryPointer.texture = this.inventoryTextures.item.pointer;
        this.inventoryPointer.x = this.inventorySlots[slotIndex].x + 5;
        const slotH = this.inventoryTextures.item.emptyBackground.height;
        this.inventoryPointer.y = this.inventorySlots[slotIndex].y + (slotH - 2);
        if ((_b = (_a = this.currentSelectedItemData) === null || _a === void 0 ? void 0 : _a.inventoryData) === null || _b === void 0 ? void 0 : _b.name) {
            this.nameSprite.visible = true;
            this.nameSprite.x = this.inventoryPointer.x;
            this.nameSprite.y = this.inventoryPointer.y - 30;
            this.nameSprite.text = (_d = (_c = this.currentSelectedItemData) === null || _c === void 0 ? void 0 : _c.inventoryData) === null || _d === void 0 ? void 0 : _d.name;
        }
        else {
            this.nameSprite.visible = false;
        }
    }
    toggleInventory(show) {
        this.inventoryContainer.visible = show;
        this.inventoryPointer.texture = this.inventoryTextures.item.pointer;
        this.inventoryPointer.visible = show;
        this.timeSinceInventoryToggled = 0;
        if (!show) {
            this.itemContextMenu.visible = false;
        }
        else {
            this.setCurrentSelectedItemOption(this.currentSelectedItemOptionIndex);
        }
    }
    onEntityAddedComponent(entity, component) {
        if (entity.type !== types_1.EntityTypes.ClientPlayer) {
            throw new Error('Only expected inventory component to be added to client player.');
        }
    }
    onPeerMessage(peerId, message) {
    }
    onServerMessage(message) {
    }
    get inventoryToggleIsCoolingDown() {
        return this.timeSinceInventoryToggled < .3;
    }
    get inventoryActionIsCoolingDown() {
        return (this.timeSinceInventoryAction < .3);
    }
    canDoInventoryInputAction(inputKey) {
        return !this.inventoryToggleIsCoolingDown && (!this.inventoryActionIsCoolingDown || !this.previousInput[inputKey]);
    }
    getValidMoveTo(input) {
        const { moveUp, moveDown, moveLeft, moveRight } = input;
        if (moveUp || moveDown || moveLeft || moveRight) {
            // same behavior for moveUp/moveDown since theres only 2 columns...
            if ((moveUp && this.canDoInventoryInputAction('moveUp')) || (moveDown && this.canDoInventoryInputAction('moveDown'))) {
                if (this.curSelectedIndex < INVENTORY_COLUMNS) {
                    return this.curSelectedIndex + INVENTORY_COLUMNS;
                }
                else {
                    return this.curSelectedIndex - INVENTORY_COLUMNS;
                }
            }
            else if (moveLeft && this.canDoInventoryInputAction('moveLeft')) {
                if (this.curSelectedIndex % INVENTORY_COLUMNS === 0) {
                    return this.curSelectedIndex + (INVENTORY_COLUMNS - 1);
                }
                else {
                    return this.curSelectedIndex - 1;
                }
            }
            else if (moveRight && this.canDoInventoryInputAction('moveRight')) {
                if ((this.curSelectedIndex + 1) % INVENTORY_COLUMNS === 0) {
                    return this.curSelectedIndex - (INVENTORY_COLUMNS - 1);
                }
                else {
                    return this.curSelectedIndex + 1;
                }
            }
        }
        return -1;
    }
    get currentSelectedItemSlot() {
        return this.inventorySlots[this.curSelectedIndex];
    }
    get currentSelectedItemData() {
        const { itemName, quantity } = this.inventorySlots[this.curSelectedIndex];
        if (itemName) {
            return {
                globalData: GameData_1.GlobalGameData.items[itemName],
                inventoryData: { index: this.curSelectedIndex, name: itemName, quantity },
            };
        }
        return null;
    }
    refreshCheckMarks() {
        var _a;
        const selectedItemName = (_a = this.currentSelectedItemData) === null || _a === void 0 ? void 0 : _a.inventoryData.name;
        this.itemContextMenu.refreshCheckMark(selectedItemName === "net", this.$api.netIsEquipped(), selectedItemName === "shovel", this.$api.shovelIsEquipped());
        setTimeout(() => {
            this.itemContextMenu.refreshCheckMark(selectedItemName === "net", this.$api.netIsEquipped(), selectedItemName === "shovel", this.$api.shovelIsEquipped());
        }, 20);
    }
    showItemOptions() {
        var _a;
        if (!this.currentSelectedItemData)
            return false;
        if (!this.currentSelectedItemData.inventoryData)
            return false;
        const type = this.currentSelectedItemData.globalData.type;
        if (!((_a = GameData_1.ItemTypeInventoryActionLookup[type]) === null || _a === void 0 ? void 0 : _a.length))
            return false;
        this.itemContextMenu.x = this.currentSelectedItemSlot.x + this.currentSelectedItemSlot.bg.width - 3;
        this.itemContextMenu.y = this.currentSelectedItemSlot.y + (this.currentSelectedItemSlot.bg.height) - 10;
        this.itemContextMenu.visible = true;
        //console.error('type was', type, 'the current sleected item data was', this.currentSelectedItemData)
        const opts = GameData_1.ItemTypeInventoryActionLookup[type].map((o) => {
            return {
                action: o,
                callback: () => {
                    var _a, _b;
                    const itemName = (_b = (_a = this.currentSelectedItemData) === null || _a === void 0 ? void 0 : _a.inventoryData) === null || _b === void 0 ? void 0 : _b.name;
                    if (!itemName)
                        return;
                    if (o === 'equip') {
                        this.dispatchLocalInstant({
                            to: [Constants_1.SYSTEMS.DIG, Constants_1.SYSTEMS.BUG_CATCH],
                            type: Constants_1.MESSAGES.EQUIP_ITEM,
                            data: itemName
                        });
                        this.refreshCheckMarks();
                    }
                    else if (o === 'plant') {
                        if (!(this.$api.plantSeed(itemName))) {
                            this.rejectAction('To plant a seed you must be facing a hole!');
                        }
                        else {
                            this.succeedAction();
                        }
                    }
                    else if (o === 'drop') {
                        if (this.globals.tileWorld.currentMap === "island") {
                            this.rejectAction('Furniture can only be placed in your house.');
                        }
                        else {
                            const { success, error } = this.$api.dropFurniture(itemName);
                            if (error) {
                                this.rejectAction('Furniture can only be placed in your house.');
                            }
                            else {
                            }
                        }
                        if (!(this.$api.dropItemFromPlayer(this.currentSelectedItemData.inventoryData.name))) {
                            //console.error('CANT DROP.')
                        }
                        else {
                            //console.error('DROPT')
                        }
                    }
                }
            };
        });
        this.inventoryPointer.texture = this.inventoryTextures.contextMenu.pointer;
        this.itemContextMenu.setOptions(opts);
        this.setCurrentSelectedItemOption(0);
        this.refreshCheckMarks();
        return true;
    }
    rejectAction(reason) {
    }
    succeedAction() {
    }
    hideItemOptions() {
        this.itemContextMenu.clear();
        this.setSelectedItemSlot(this.curSelectedIndex);
    }
    setCurrentSelectedItemOption(index) {
        this.currentSelectedItemOptionIndex = index;
        this.itemContextMenu.setSelectedOption(index);
        if (this.itemContextMenu.options[index]) {
            this.inventoryPointer.x = this.itemContextMenu.x - (this.inventoryPointer.width / 2 + 7);
            this.inventoryPointer.y = this.itemContextMenu.y + this.itemContextMenu.options[index].y;
        }
    }
    get currentSelectedItemOptionText() {
        if (this.itemContextMenu.visible) {
            // @ts-ignore
            return this.itemContextMenu.children[this.currentSelectedItemOptionIndex].children[1].text;
        }
        return null;
    }
    recenterInterface() {
        /*
        const { ratioW, ratioH } = this.globals.tileWorld.playerCamera;
        const centerX = (window.innerWidth / 2) - ((this.inventoryTextures.background.width / ratioW)/2);
        const centerY = (window.innerHeight / 2) - ((this.inventoryTextures.background.height / ratioH)/2);
        const { x, y } = this.globals.tileWorld.playerCamera.screenToWorld(centerX, centerY)
        this.inventoryContainer.x = x-this.globals.tileWorld.playerCamera.playerViewRect.x;
        this.inventoryContainer.y = y-this.globals.tileWorld.playerCamera.playerViewRect.y;

         */
        const screenWidth = this.globals.renderer.screen.width;
        const screenHeight = this.globals.renderer.screen.height;
        this.inventoryContainer.x = (screenWidth / 2) - (this.inventoryTextures.background.width / 2);
        this.inventoryContainer.y = (screenHeight / 2) - (this.inventoryTextures.background.height / 2);
    }
    doMoveSelectedItemOption(up, down) {
        if (down) {
            if (this.currentSelectedItemOptionIndex === this.itemContextMenu.options.length - 1) {
                this.setCurrentSelectedItemOption(0);
            }
            else {
                this.setCurrentSelectedItemOption(this.currentSelectedItemOptionIndex + 1);
            }
        }
        else if (up) {
            if (this.currentSelectedItemOptionIndex === 0) {
                this.setCurrentSelectedItemOption(this.itemContextMenu.options.length - 1);
            }
            else {
                this.setCurrentSelectedItemOption(this.currentSelectedItemOptionIndex + 1);
            }
        }
    }
    onStop() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('resize', this.recenterInterface);
        }
        else if (typeof document !== 'undefined') {
            document.removeEventListener('resize', this.recenterInterface);
        }
    }
    get curSelectedOptionCallback() {
        if (this.itemContextMenu.visible && this.itemContextMenu.options[this.currentSelectedItemOptionIndex]) {
            return this.itemContextMenu.options[this.currentSelectedItemOptionIndex].callback;
        }
        return () => { };
    }
    update(delta) {
        if (!this.$api.gameStateInitialized() || !this.clientPlayer)
            return;
        const { inventory, grab, pickup, moveDown, moveUp, cancel, escape } = this.clientPlayer.playerInput;
        this.timeSinceInventoryToggled += delta;
        if (inventory && !this.inventoryToggleIsCoolingDown) {
            this.toggleInventory(!this.isOpen);
        }
        this.timeSinceInventoryAction += delta;
        if (this.isItemMenuOpen) {
            this.updatePointer(delta * 15);
            if ((grab && this.canDoInventoryInputAction('grab')) || (pickup && this.canDoInventoryInputAction('pickup'))) {
                this.curSelectedOptionCallback();
                this.timeSinceInventoryAction = 0;
            }
            else if ((moveDown && this.canDoInventoryInputAction('moveDown')) || (moveUp && this.canDoInventoryInputAction('moveUp'))) {
                if (!this.$api.isInDialogueResponse()) {
                    this.doMoveSelectedItemOption(moveUp && this.canDoInventoryInputAction('moveUp'), moveDown && this.canDoInventoryInputAction('moveDown'));
                }
                this.timeSinceInventoryAction = 0;
            }
            else if (cancel && this.canDoInventoryInputAction('cancel')) {
                this.hideItemOptions();
                this.timeSinceInventoryAction = 0;
            }
        }
        else if (this.isOpen) {
            this.updatePointer(delta * 15);
            const moveTo = this.getValidMoveTo(this.clientPlayer.playerInput);
            if (moveTo > -1) {
                this.setSelectedItemSlot(moveTo);
                this.timeSinceInventoryAction = 0;
            }
            else if ((grab && this.canDoInventoryInputAction('grab')) || (pickup && this.canDoInventoryInputAction('pickup'))) {
                const showed = this.showItemOptions();
                if (showed)
                    this.timeSinceInventoryAction = 0;
            }
            else if (cancel && this.canDoInventoryInputAction('cancel')) {
                this.toggleInventory(false);
                this.timeSinceInventoryAction = 0;
            }
        }
        this.previousInput = Object.assign({}, this.clientPlayer.playerInput);
    }
}
exports.InventorySystem = InventorySystem;
//# sourceMappingURL=module.js.map